// extracted by mini-css-extract-plugin
export var atcOriginPrice = "styles-module--atcOriginPrice--KJo17";
export var bundleContainer = "styles-module--bundleContainer--Xpyvm";
export var container = "styles-module--container--8ZRBN";
export var customProgressBar = "styles-module--custom-progress-bar--NEQj0";
export var greenText = "styles-module--greenText--WO+--";
export var mobilePopUp = "styles-module--mobilePopUp--wm93r";
export var open = "styles-module--open--WITqE";
export var progressMobileContainer = "styles-module--progressMobileContainer--FHeVV";